/* Cart drawer — AJAX add-to-cart + slide-out cart. Works site-wide (any {% form 'product' %}).
   Uses Shopify's Cart AJAX API + Section Rendering API so Liquid stays the source of truth
   (money formatting, selling-plan/subscription lines from Appstle, etc.). */
(function () {
  var SECTION = 'cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function url(path) { return root.replace(/\/$/, '') + path; }

  function getDrawerHost() { return document.getElementById('shopify-section-' + SECTION); }

  function openDrawer() { document.body.classList.add('cart-open'); }
  function closeDrawer() { document.body.classList.remove('cart-open'); }

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n || n < 1;
      el.classList.toggle('is-empty', !n || n < 1);
    });
  }

  // Replace the drawer's rendered HTML from a Section Rendering API payload (full section markup).
  function swapSection(html) {
    var host = getDrawerHost();
    if (!host || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    // Shopify may return the section wrapped in #shopify-section-… or just its inner content.
    var wrapped = tmp.querySelector('#shopify-section-' + SECTION);
    host.innerHTML = wrapped ? wrapped.innerHTML : html;
  }

  function refreshFromCart() {
    return fetch(url('/?sections=' + SECTION), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data && data[SECTION]) swapSection(data[SECTION]); });
  }

  function syncCount() {
    return fetch(url('/cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count); return c; })
      .catch(function () {});
  }

  /* Un solo sitio en el tema sabe si un alta termino bien; el resto se entera
     por este evento en vez de volver a interceptar el formulario. `variantId`
     puede faltar (Shopify responde distinto segun la forma del alta) y quien
     escuche tiene que saber apanarselas sin el. */
  function anunciarAlta(data) {
    var vid = null;
    if (data) {
      if (data.id) { vid = data.id; }
      else if (data.items && data.items.length) { vid = data.items[0].id; }
    }
    document.dispatchEvent(new CustomEvent('lb:cart:added', { detail: { variantId: vid } }));
  }


  /* Un fallo al añadir se cuenta DENTRO del cajón, no con un alert() del
     navegador: un diálogo nativo a mitad de una compra corta el flujo y en
     una landing de pago se lleva la conversión por delante.
     El error completo queda en consola para poder diagnosticarlo después. */
  function showCartError(res, contexto) {
    var msg = (res && res.data && (res.data.description || res.data.message)) ||
              'No pudimos agregar este producto. Intenta de nuevo.';
    try {
      console.error('[cart] alta fallida (' + contexto + ')', {
        status: res && res.status,
        shopify: res && res.data,
        url: window.location.href
      });
    } catch (e) {}

    openDrawer();
    var host = getDrawerHost();
    var panel = host && host.querySelector('.cart-drawer__panel');
    var mount = panel || host;
    if (!mount) { return; }

    var old = mount.querySelector('[data-cart-error]');
    if (old) { old.remove(); }

    var box = document.createElement('div');
    box.setAttribute('data-cart-error', '');
    box.setAttribute('role', 'alert');
    box.style.cssText = 'margin:12px;padding:12px 14px;border:1px solid #f0c9c1;' +
      'background:#fbeeea;color:#8c2f22;border-radius:10px;font-size:.9rem;line-height:1.45';
    box.textContent = msg;
    mount.insertBefore(box, mount.firstChild);
    /* se va sola: no debe quedarse pegada cuando el cliente reintenta */
    setTimeout(function () { if (box.parentNode) { box.remove(); } }, 8000);
  }

  /* Shopify instrumenta el alta al carrito por DOS caminos: envuelve `fetch`
     y ademas engancha un `submit` SOBRE el propio <form action="/cart/add">.
     Ese segundo camino solo se calla si el evento ya llega con
     defaultPrevented. Nuestro interceptor de abajo esta delegado en
     `document` (burbuja) y, por orden de despacho del DOM, corre DESPUES del
     listener que Shopify pone en el form — asi que Shopify publicaba un
     `product_added_to_cart` de mas y Meta contaba DOS AddToCart por una sola
     peticion a /cart/add.js. Medido en vivo: 1 POST, 2 eventos, eventID
     distintos (o sea, no es la deduplicacion de la CAPI).

     Esto lo apaga en CAPTURA, antes de que corra el de Shopify. Queda solo el
     evento de la via `fetch`, que es el bueno: sale del carrito de verdad y no
     de una estimacion leida del formulario.

     OJO: no mover el listener de abajo a captura. Correria antes que los
     handlers propios de las landings de pago (lp-buy, lp-single, fast-figma-
     hero...) y alli si se anadiria dos veces al carrito. */
  document.addEventListener('submit', function (e) {
    var fAdd = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (fAdd) e.preventDefault();
  }, true);

  // ---- Add to cart (intercept every product form) ----
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[name="add"]');
    if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

    var added = null;
    var fd = new FormData(form);
    fd.append('sections', SECTION);
    fd.append('sections_url', window.location.pathname);

    fetch(url('/cart/add.js'), { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); })
      .then(function (res) {
        if (!res.ok) {
          showCartError(res, 'formulario de producto');
          return;
        }
        added = res.data;
        if (res.data.sections && res.data.sections[SECTION]) {
          swapSection(res.data.sections[SECTION]);
        } else {
          return refreshFromCart();
        }
      })
      .then(function () { return syncCount(); })
      .then(function () { openDrawer(); anunciarAlta(added); })
      .catch(function (err) { console.error('[cart] add failed', err); })
      .finally(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.disabled = false; }
      });
  });

  // ---- Drawer interactions (delegated, survive innerHTML swaps) ----
  document.addEventListener('click', function (e) {
    // open from header cart icon / any [data-cart-toggle]
    var toggle = e.target.closest && e.target.closest('[data-cart-toggle]');
    if (toggle) {
      e.preventDefault();
      openDrawer();
      refreshFromCart();
      return;
    }

    // close
    if (e.target.closest && e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    // bundle upsell — add straight from the drawer instead of leaving for the PDP
    var up = e.target.closest && e.target.closest('[data-upsell-add]');
    if (up) {
      e.preventDefault();
      if (up.getAttribute('aria-busy') === 'true') { return; }
      up.setAttribute('aria-busy', 'true');
      var body = new FormData();
      body.append('id', up.getAttribute('data-upsell-add'));
      body.append('quantity', '1');
      body.append('sections', SECTION);
      body.append('sections_url', window.location.pathname);
      fetch(url('/cart/add.js'), { method: 'POST', headers: { 'Accept': 'application/json' }, body: body })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, data: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            showCartError(res, 'upsell del cajón');
            return;
          }
          /* The re-rendered section drops this card by itself: the strip only
             lists products that are NOT already in the cart. */
          if (res.data.sections && res.data.sections[SECTION]) { swapSection(res.data.sections[SECTION]); }
          else { return refreshFromCart(); }
        })
        .then(function () { return syncCount(); })
        .catch(function (err) { console.error('[cart] upsell add failed', err); })
        .finally(function () {
          /* The node is usually gone with the swap; this only matters when the
             add failed and the same card is still on screen. */
          if (up.isConnected) { up.removeAttribute('aria-busy'); }
        });
      return;
    }

    // quantity change / remove
    var qbtn = e.target.closest && e.target.closest('[data-cart-qty]');
    if (qbtn) {
      var line = qbtn.closest('[data-cart-line]');
      if (!line) return;
      var body = qbtn.closest('.cart-drawer__panel');
      if (body) body.classList.add('is-busy');
      var payload = { line: parseInt(line.getAttribute('data-cart-line'), 10), quantity: parseInt(qbtn.getAttribute('data-cart-qty'), 10), sections: SECTION, sections_url: window.location.pathname };
      fetch(url('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.sections && data.sections[SECTION]) swapSection(data.sections[SECTION]);
          else return refreshFromCart();
          setCount(data.item_count);
        })
        .then(function () { return syncCount(); })
        .catch(function (err) { console.error('[cart] change failed', err); });
    }
  });

  // Esc closes
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Keep the count badge correct on load
  document.addEventListener('DOMContentLoaded', syncCount);

  /* Superficie minima para que otras piezas del tema usen ESTE drawer en vez de
     reimplementarlo o mandar a la pagina de carrito. */
  window.LBCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshFromCart,
    syncCount: syncCount,
  };
})();
